import BaseCarouselSlick from '../abstracts/BaseCarouselSlick';

export default class CarouselComponentSlick extends BaseCarouselSlick {
  
  constructor(element) {
    super(element);
    this.mount(this.$el, this.$options);
  }
  
}